import { UIHeading1, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';

import { trackAdvantages, VIEWED_TIMEOUT } from '../tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useGetAdvantagesContent } from './content';

export const Advantages: React.FC = () => {
  const content = useGetAdvantagesContent();

  return (
    <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackAdvantages}>
      <div data-testid="Advantages" className={styles['container']}>
        <div className={styles['main-title']}>
          <UIHeading1>Чем поможет Мой дом</UIHeading1>
        </div>
        <div className={styles['content']}>
          {content.map((item, i) => {
            return (
              <div key={i} className={styles['content-item']}>
                <div className={styles['img']}>
                  <img className={styles[`img-${item.className}`]} src={item.imgUrl} />
                </div>
                <div className={styles['sub-title']}>
                  <UIHeading2>{item.title}</UIHeading2>
                </div>
                <UIText1>{item.text}</UIText1>
              </div>
            );
          })}
        </div>
      </div>
    </ActionAfterViewObserver>
  );
};
